module.exports = __webpack_public_path__ + "static/media/pop&gar.7bd4270c.jpeg";